import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const TenantLogo = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 151 20"
      fill="none"
      {...rest}
    >
      <g clipPath="url(#clip0_9950_262)">
        <g clipPath="url(#clip1_9950_262)">
          <path
            d="M29.0108 0.43457L15.9663 12.1778L11.0259 16.635H0.599609L5.81275 11.9362L10.7609 7.48672L18.5845 0.43457H29.0108Z"
            fill="#F88C00"
          />
          <path d="M32.3307 19.565H22.4421L15.1094 12.957H24.998L32.3307 19.565Z" fill={fill} />
        </g>
        <g clipPath="url(#clip2_9950_262)">
          <path
            d="M39.2539 1.09521H52.2445C53.7396 1.09521 55.0177 1.62197 56.0712 2.68322C57.1248 3.74447 57.6593 5.01487 57.6593 6.50992C57.6593 8.00497 57.1325 9.28311 56.0712 10.3366C55.01 11.3979 53.7396 11.9246 52.2445 11.9246H42.4996V19.5083H39.2539V1.09521ZM42.4996 4.34868V8.6789H52.2445C52.841 8.6789 53.3523 8.46975 53.7783 8.0437C54.2044 7.62539 54.4135 7.11413 54.4135 6.50992C54.4135 5.9057 54.2044 5.40219 53.7783 4.97614C53.36 4.55009 52.8488 4.34094 52.2445 4.34094H42.4996V4.34868Z"
            fill={fill}
          />
          <path
            d="M65.9176 11.9246V16.2548H81.0772V19.5006H62.6719V1.09521H81.0772V4.34094H65.9176V11.9169V11.9246Z"
            fill={fill}
          />
          <path
            d="M104.493 14.0936C104.493 15.5886 103.966 16.8668 102.905 17.9203C101.844 18.9738 100.574 19.5083 99.0785 19.5083H86.0879V1.09521H99.0785C100.574 1.09521 101.852 1.62197 102.905 2.68322C103.959 3.74447 104.493 5.01487 104.493 6.50992V14.0859V14.0936ZM99.0785 16.2548C99.675 16.2548 100.186 16.0457 100.612 15.6196C101.038 15.1936 101.248 14.6901 101.248 14.0859V6.50992C101.248 5.91345 101.038 5.40219 100.612 4.97614C100.194 4.55009 99.6827 4.34094 99.0785 4.34094H89.3336V16.2548H99.0785Z"
            fill={fill}
          />
          <path
            d="M112.093 16.255L110.218 19.5008H106.461L115.571 3.73693L117.445 0.491211L119.32 3.73693L128.43 19.5008H124.673L122.798 16.255H112.1H112.093ZM120.916 13.0093L117.438 6.99041L113.959 13.0093H120.908H120.916Z"
            fill={fill}
          />
          <path d="M132.195 1.09521H135.441V16.2548H150.601V19.5006H132.195V1.09521Z" fill={fill} />
          <path d="M77.9925 8.6792H59.502V11.9249H77.9925V8.6792Z" fill="#F88C00" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_9950_262">
          <rect width="150" height="19.1304" fill={fill} transform="translate(0.599609 0.43457)" />
        </clipPath>
        <clipPath id="clip1_9950_262">
          <rect width="31.7308" height="19.1304" fill={fill} transform="translate(0.599609 0.43457)" />
        </clipPath>
        <clipPath id="clip2_9950_262">
          <rect width="111.346" height="19.0173" fill={fill} transform="translate(39.2539 0.491211)" />
        </clipPath>
      </defs>
    </svg>
  );
};

TenantLogo.displayName = 'TenantLogo';
